import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import domain from "../../config/domain";
import GlobalStore from "../store/globalStore";

// Define SDK type for TypeScript safety
declare global {
  interface Window {
    AinxtSDK: {
      Initialize: (
        token: string,
        callback: (data: any) => void,
        mode: string,
        clientId: string,
        kycId: string,
        requestId: string
      ) => void;
    };
  }
}

const NomineeSdkCheck = forwardRef((props: any, ref) => {
  const [token, setToken] = useState<string>("");
  const [sdkData, setSdkData] = useState<any>(null);
  const [clientId, setClientId] = useState<string>("nuvama");
  const [kycId, setKycId] = useState<string>(GlobalStore.applicationID);
  const [requestId, setRequestId] = useState<string>("");
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [imageBase64, setImageBase64] = useState<string>("");

  const onStartFromRecording = () => {
    console.log("NomineeSdkCheck ---> Received START RECORDING");
    initializeSDK()
  };

  useImperativeHandle(ref, () => ({
    onStartFromRecording
  }));

  useEffect(() => {
    fetchToken()
  }, [])

  const fetchToken = () => {
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "dgHnYHpcBxajmdmlWymPO40PVFzaTkvq75hHHj5m");
    myHeaders.append("authorizationToken", "M716Cq1I2qDUTh1z");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      clientid: clientId,
      kycid: kycId,
      requestid: requestId
    });

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };

    fetch(domain.sdkNomineeVideoUrl, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setToken(data.token || "");
        console.log("Token Response:", data);
      })
      .catch((error) => console.error("Error fetching token:", error));
  };

  const handleSDKData = (data: any) => {
    setSdkData(data);
    console.log("SDK Response ==> ", data);

    if (data?.request_id && data?.client_id && data?.kyc_id) {
      fetchGetData(data.request_id, data.client_id, data.kyc_id);
    }
  };

  const convertBase64ToVideoURL = (base64: string, type = "video/mp4") => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    const blob = new Blob(byteArrays, { type });
    return URL.createObjectURL(blob);
  };


  const fetchGetData = (requestId: string, clientId: string, kycId: string) => {
    const headers = {
      "x-api-key": "dgHnYHpcBxajmdmlWymPO40PVFzaTkvq75hHHj5m",
      "authorizationToken": "M716Cq1I2qDUTh1z",
      "Content-Type": "application/json",
    };

    fetch("https://ainxt.nomineeoptout.uat.ainxtkyc.com/getdata", {
      method: "POST",
      headers,
      body: JSON.stringify({ requestid: requestId, clientid: clientId, kycid: kycId }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("GetData ===>", result);

        if (result.face_content) {
          setImageBase64(`data:image/jpeg;base64,${result.face_content}`);
        }
        if (result.video_content) {
          const videoBlobURL = convertBase64ToVideoURL(result.video_content);
          setVideoUrl(videoBlobURL);
        }

        // Send to parent
        props?.onSdkResult?.({
          video: convertBase64ToVideoURL(result.video_content),
          faceImage: result.face_content ? `data:image/jpeg;base64,${result.face_content}` : "",
          raw: result
        });
      })
      .catch((error) => console.error("Error:", error));
  };

  const initializeSDK = () => {
    if (!window.AinxtSDK) {
      console.error("AinxtSDK is not loaded!");
      return;
    }

    window.AinxtSDK.Initialize(
      token,
      handleSDKData,
      "0", // mode
      clientId,
      kycId,
      requestId
    );
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = domain.sdkNomineeVideoScript;
    script.async = true;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="text-center">
    </div>
  );
});

export default NomineeSdkCheck;
